import React from "react";
import Rbac from "../../../utils/Rbac";
import TransactionsView from "./components/TransactionsView";
import SalesBillingsView from "./components/SalesBillingsView";
import InsurancesView from "./components/InsurancesView";
import AdminTransactionsView from "./components/AdminTransactionsView";
import { isViewVisible } from "../../../utils/ViewSettings";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editFinance: true,
    },
    manager: {
      write: true,
      editFinance: true,
    },
    "booking-manager": {
      write: false,
      editFinance: false,
    },
    "manager-location": {
      write: false,
      editFinance: false,
    },
    user: {
      write: false,
      editFinance: false,
    },
    "garage-staff": {
      write: false,
      editFinance: false,
    },
  },
});

export const FinancesPage = (props) => {
  var _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  var indexView = isViewVisible("transactions", "finances")
    ? "transactions"
    : isViewVisible("salesBillings", "finances")
      ? "sales_billings"
      : "payment_accounts";

  return (
    <>
      {(_view == "transactions" || (_view == "index" && indexView == "transactions")) && (
        <TransactionsView name={"transactions"} dispatch={props.dispatch} />
      )}
      {(_view == "sales_billings" || (_view == "index" && indexView == "sales_billings")) && (
        <SalesBillingsView name={"sales_billings"} dispatch={props.dispatch} />
      )}
      {(_view == "payment_accounts" || (_view == "index" && indexView == "payment_accounts")) && (
        <SalesBillingsView name={"payment_accounts"} dispatch={props.dispatch} />
      )}
      {(_view == "insurances" || (_view == "index" && indexView == "insurances")) && (
        <InsurancesView name={"insurances"} dispatch={props.dispatch} />
      )}
      {(_view == "admin_transactions" ||
        (_view == "index" && indexView == "admin_transactions")) && (
        <AdminTransactionsView name={"transactions"} dispatch={props.dispatch} />
      )}
    </>
  );
};
